import { API_BASE } from '../config';

export const deleteEntity = async ({ entityType, entityId, onDeleted, event, confirmationMessage }) => {
  if (event && typeof event.stopPropagation === 'function') {
    event.stopPropagation();
  }
  const confirmMessage = confirmationMessage || `Are you sure you want to delete this ${entityType.slice(0, -1)}?`;
  if (!window.confirm(confirmMessage)) {
    return;
  }
  try {
    const response = await fetch(`${API_BASE}/api/${entityType}/${entityId}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || `Failed to delete ${entityType.slice(0, -1)}`);
    }
    if (onDeleted && typeof onDeleted === 'function') {
      onDeleted();
    }
  } catch (error) {
    console.error('Error:', error);
    alert(error.message || `Failed to delete ${entityType.slice(0, -1)}`);
  }
};
